// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Manual alarm rule_id -> sop_artifact_id fallback, used when neither the alarm
// rule's related documents nor the SOP Factory catalog resolve a procedure.
// Rule ids match an alarm's `alarm_code` by convention (there is no FK).
// Resolution otherwise flows through the SOP Factory catalog exactly as a real
// related-document link would (see useAlarms.loadAlarmWithSop).

/** Manual `rule_id` → `sop_artifact_id` fallback table. */
export const MANUAL_SOP_BY_RULE_ID: Record<string, string> = {
  'ELE-OEM-GEN-010': 'SOP-TEDC-GA10-MOCK-DRILL-EXECUTION',
  'ELE-OEM-UPS-012': 'SOP-LED-ALARM-COLOR-CODE-REFERENCE-001',
  'MEC-A-013': 'GA10-CHILLED-WATER-SYSTEM-SOP-IMMEDIATE-ALARM-RESPONSE',
};

/** First manually-mapped SOP artifact id for any of the given rule ids, or undefined. */
export function manualSopIdForRules(ruleIds: string[] | undefined): string | undefined {
  return ruleIds?.map(id => MANUAL_SOP_BY_RULE_ID[id]).find(Boolean);
}
